import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider, theme } from '@sgi/gravity';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Loading } from '../../components';
import { Box, Flex, createStandaloneToast } from '@chakra-ui/react';
import { useAreModulesReady } from '../../../';
import { AppFooter, AppHeader, AppSideBar } from './components';
export function CustomerLayout() {
    const isReady = useAreModulesReady();
    const { ToastContainer } = createStandaloneToast({ theme });
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsxs(Box, { children: [_jsx(Box, { position: "relative", zIndex: 2, children: _jsx(AppHeader, {}) }), _jsxs(Flex, { position: "relative", zIndex: 1, children: [_jsx(Box, { position: "sticky", top: "0", height: "100%", zIndex: 999, children: _jsx(AppSideBar, {}) }), _jsxs(Box, { minH: "100%", w: "100vw", backgroundColor: "gray.50", children: [_jsx(Suspense, { fallback: _jsx(Loading, {}), children: isReady && _jsx(Outlet, {}) }), _jsx(AppFooter, {})] })] })] }), _jsx(ToastContainer, {})] }));
}
